import { hexToRGB } from '.'

export function parseCssVars(category) {
  let image_url = '/assets/img/000_Class_pic_Basic.jpg'
  let color = '#ffffff'
  let border_color = '#ffffff'

  if (category) {
    if (category.image_url) {
      image_url = encodeURI(decodeURI(category.image_url))
    }
    if (category.c_background_color) {
      color = category.c_background_color
    }

    if (category.border_color) {
      border_color = category.border_color
    }
  }
  return '--image-url: url(' + image_url + '); ' +
      '--color: ' + color + ';' +
      '--color-rgb: ' + hexToRGB(color) + ';' +
      '--border-color: ' + border_color + ';' +
      '--border-color-rgb: ' + hexToRGB(border_color) + ';'
}
